import React from 'react'
import { Modal, Icon, Divider } from 'antd'
import { useTranslation } from 'react-i18next'
import { useTour } from './hooks/useTour'
import { tourConfigs } from './configs/tourConfigs'
import './Tour.scss'

const TourModal = () => {
    const { t } = useTranslation()
    const { isModalOpen, closeTourModal, startTour, pausedTours, resumeTour, tourOptions } = useTour()

    // Categorize tours
    const categories = {
        'Interface': [
            'toolbar-guide',
            'background-image-settings',
            'background-color-settings'
        ],
        'Content Generation': [
            'story-generation',
            'scenario-generation',
            'quiz-generation',
            'infographics-generation',
            'interactive-generation',
            'world-scenario-generation',
            'add-content-generation',
            'match-image-generation'
        ]
    }

    const getCategoryTours = (tourIds) => {
        return tourIds
            .map(id => {
                let config = tourConfigs[id]
                if (typeof config === 'function') {
                    config = config(t)
                }
                return { id, ...config }
            })
            .filter(tour => tour && !tour.hidden)
    }

    return (
        <Modal
            visible={isModalOpen}
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Icon type="compass" style={{ color: '#1890ff', fontSize: '20px' }} />
                    <span>Guided Tours</span>
                </div>
            }
            onCancel={closeTourModal}
            footer={null}
            width={680}
            centered
            bodyStyle={{ padding: '16px 24px' }}
        >
            <div className="tour-modal-content">
                {pausedTours && pausedTours.length > 0 && (
                    <>
                        <div
                            className="tour-resume-card"
                            onClick={resumeTour}
                        >
                            <Icon type="play-circle" className="tour-resume-icon" />
                            <div className="tour-resume-text">
                                <strong>Resume Tour</strong>
                                <span>Continue where you left off</span>
                            </div>
                        </div>
                        <Divider style={{ margin: '16px 0' }} />
                    </>
                )}

                {Object.entries(categories).map(([categoryName, tourIds]) => {
                    if (!tourOptions.isAiGeneratedCourse && categoryName === 'Content Generation') {
                        return null
                    }
                    const categoryTours = getCategoryTours(tourIds)
                    if (categoryTours.length === 0) return null

                    return (
                        <div key={categoryName} className="tour-category">
                            <h4 className="tour-category-title">{categoryName}</h4>
                            <div className="tour-list">
                                {categoryTours.map(tour => (
                                    <div
                                        key={tour.id}
                                        className="tour-item"
                                        onClick={() => startTour(tour.id)}
                                    >
                                        <Icon type={tour.icon || 'compass'} className="tour-item-icon" />
                                        <div className="tour-item-content">
                                            <div className="tour-item-name">{tour.name}</div>
                                            <div className="tour-item-desc">{tour.description}</div>
                                        </div>
                                        <Icon type="right" className="tour-item-arrow" />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )
                })}
            </div>
        </Modal>
    )
}

export default TourModal
